import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import StickyHeader from "../../../../components/Layout/StickyHeader";

import CommonButton from "../../../../components/Button";
import { AuthHeader } from "../../../../components/Layout/Auth/Header";

type Props = {};

export default function FindIdComplete(props: Props) {
  const location = useLocation();
  const params = location.state || {};
  const navigate = useNavigate();

  useEffect(() => {
    if (!("email" in params)) {
      navigate("/auth/findId");
    }
  }, [params]);

  return (
    <div className="px-5">
      <StickyHeader title="아이디 확인" />
      <AuthHeader ruleClassName="border-black">
        고객님의
        <br />
        <strong>아이디</strong>를 찾았어요!
      </AuthHeader>

      <div className="py-5">
        <div className="flex flex-col gap-2">
          <div className="flex justify-between text-sm text-brand-neutral-60">
            <div>가입 아이디</div>
            <div>{params.createdAt} 가입</div>
          </div>
          <div className=" text-lg font-medium">{params.email}</div>
        </div>
      </div>

      <CommonButton
        variant="tertiary"
        className="text-sm text-brand-neutral-60 w-full"
        onClick={() => navigate("/auth/findPassword")}
      >
        비밀번호 재설정
      </CommonButton>

      <CommonButton
        className="fixed bottom-0 left-0 right-0 text-base font-medium h-bottom-button"
        onClick={() => navigate("/auth/login")}
      >
        로그인 하기
      </CommonButton>
    </div>
  );
}
